import { enqueueSnackbar } from "./notification.context";
import { FxNotificationPayload, FxNotificationType, notificationMatcher, NotificationPayload } from "./type";

export const notifyFromFlax = (payload: FxNotificationPayload, type: FxNotificationType) => {
  const notificationType = notificationMatcher[type];

  return notifyInternal({ message: payload, severity: notificationType });
};

export const notifyInternal = (payload: NotificationPayload) => {
  return enqueueSnackbar(payload);
};
